export default {"src":"/_next/static/media/time_blue_filled.2ff0a663.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};